import axios from 'axios';
import { store } from '@/store/store';
import { ApiRoutes } from '../ApiRoutes';
import { AuthDiagnosticReport } from '@/types/webContracts';

// MM-42239: fetch the single-use "get" copy of the OIDC-return diagnostics report. The ticketId is POSTed in the
// body (not a query string) so it stays out of access logs / Referer; the session binding (StateGuid) rides along
// automatically in the HttpOnly diagnostics binding cookie. The backend redeems (removes) the cache copy on read,
// so this can only succeed once.
export async function getOIDCReturnDiagnostics(ticketId: string): Promise<AuthDiagnosticReport | null> {
  store.state.loadingCount++;
  const result = await axios.post(ApiRoutes.Diagnostics.OIDCReturn, { ticketId })
      .then(response => response.data as AuthDiagnosticReport)
      .catch(() => null)
      .finally(() => {
        store.state.loadingCount--;
      });

  return result ?? null;
}

// MM-42239: email the single-use "submit" copy to the configured recipients. No antiforgery token is sent: the
// endpoint is keyed by an unguessable single-use ticket bound to the session via the HttpOnly binding cookie (its
// own CSRF capability) and is non-prod only, so the fragile partitioned-cookie token round-trip is unnecessary here.
export async function submitOIDCReturnDiagnostics(ticketId: string): Promise<boolean> {
  store.state.loadingCount++;
  try {
    await axios.post(ApiRoutes.Diagnostics.OIDCReturnSubmit, { ticketId });
    return true;
  } catch (e) {
    console.log(e);
    return false;
  } finally {
    store.state.loadingCount--;
  }
}
